import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[onlyDigits]',
    standalone: false
})
export class OnlyDigitsDirective {

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyDown(_event: Event) {
    const event = _event as KeyboardEvent;
    // Allow: backspace, delete, tab, escape, enter
    if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true) ||
      // Allow: home, end, left, right
      (event.keyCode >= 35 && event.keyCode <= 39) ||
      // Allow: minus for negative numbers
      (event.keyCode === 189 || event.keyCode === 109)) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(_event: Event) {
    const event = _event as ClipboardEvent;
    const pastedInput: string = event.clipboardData?.getData('text/plain') || '';
    if (pastedInput && !/^-?\d*\.?\d*$/.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
